import angular from 'angular';
import { MeurhSolicitacoesgenericasDocumentosanexosFormController } from './documentosanexos.form.controller';

export class MeurhSolicitacoesgenericasDocumentosanexosFormComponent implements angular.IComponentOptions {
	static selector = 'meurhSolicitacoesgenericasDocumentosanexosFormComponent';
	static controller = MeurhSolicitacoesgenericasDocumentosanexosFormController;
	static template = require('!!html-loader!./documentosanexos.form.html');
	static transclude = true;
	static bindings = {
		busy: '=',
		busyTipoDocumentos: '=',
		entityanexo: '=',
		file: '=?',
		action: '=?',
		mostrarAlerta: '=',
		tiposdocumentosrequeridos: '=',
		editanexo: '=',
		alterouanexo: '=',
		fileSelecionado: '=?',
		validateResult: '=?',
	};
}
